import { createContext } from "solid-js";

export const ReduxContext = createContext({ store: {}, state: {} });
export default ReduxContext;